var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Field } from '../elements';
import React from 'react';
import { t } from '../helpers/i18n';
import View from '../elements/View';
var FieldPrice = function (props) {
    var _a;
    var field = props.field, withTiers = props.withTiers, isPriceCalendar = props.isPriceCalendar, pricesValues = props.pricesValues, onChangePrice = props.onChangePrice, onSavePrice = props.onSavePrice, onDeleteClick = props.onDeleteClick, onDefaultPrice = props.onDefaultPrice;
    if (!pricesValues)
        return null;
    var val;
    if (isPriceCalendar) {
        val = (field.value !== undefined && field.value !== null) ? field.value : '';
    }
    else {
        var klkey = (_a = field.column) !== null && _a !== void 0 ? _a : field.name;
        val = pricesValues[klkey];
    }
    return (React.createElement(View, { row: true, style: {}, key: "View_".concat(field.name) },
        field.value !== undefined && field.value !== null && field.value > 0 && onDefaultPrice && React.createElement("button", { onClick: function () {
                if (onDefaultPrice && typeof onDefaultPrice === 'function') {
                    onDefaultPrice(field);
                }
            } }, t('toDefault')),
        onDefaultPrice && React.createElement("button", { className: 'cui-trash', onClick: function () {
                if (onDeleteClick && typeof onDeleteClick === 'function') {
                    onDeleteClick(field);
                }
            } }),
        React.createElement(Field, { key: field.name, reactstrap: true, field: __assign(__assign({}, field), { type: 'price', value: val }), onChange: onChangePrice, onSavePrice: onSavePrice })));
};
export default FieldPrice;



//////////////////
// WEBPACK FOOTER
// ./src/components/FieldPrice.tsx
// module id = 1415
// module chunks = 0